import React from 'react'
import styled from 'styled-components'
import CTALine from '../assets/images/cta-line.svg'
import NewsletterSignup from '../components/NewsletterSignup'

export function SecondaryCTA() {
  return (
    <Container>
      <div className="cta-form secondary-cta">
        <IllustrationWrapper>
          <Illustration src={CTALine} />
        </IllustrationWrapper>
        <p className="secondary-cta_intro">
          <b>Subscribe to our newsletter</b>
          <br />
          Get the latest product updates and #goodreads delivered to your inbox
          once a month.
        </p>
        <NewsletterSignup />
      </div>
    </Container>
  )
}

export default SecondaryCTA

const Illustration = styled.img`
  margin: 0 0 64px;
`

const IllustrationWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  overflow: hidden;
`

const Container = styled.div`
  width: 100%;
  padding: 64px 0 80px;
  @media screen and (max-width: 800px) {
    padding: 48px 0 64px;
  }

  .secondary-cta_intro {
    margin-bottom: 16px;
    line-height: 1.8rem;
  }
`
